import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API from "../../services/api"; // ajuste o caminho conforme necessário

const Games = () => {
  const [games, setGames] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    API.get("/games").then((res) => setGames(res.data));
  }, []);

  return (
    <div className="p-6 mt-20">
      <h1 className="text-2xl font-bold mb-4">Jogos</h1>
      <div className="mt-4 grid gap-4">
        {games.map(
          (game) =>
            game.publico && (
              <div key={game._id} className="p-4 rounded-xl shadow bg-white">
                <div className="flex justify-between">
                  <div>
                    <p>
                      <strong>Data:</strong> {game.date}
                    </p>
                    <p>
                      <strong>Campeonato:</strong> {game.league} - {game.season}
                    </p>
                    <p>
                      <strong>Times:</strong>{" "}
                      {game.teams?.home?.name ?? "Sem time"} x{" "}
                      {game.teams?.away?.name ?? "Sem time"}
                    </p>
                  </div>
                  <div>
                    <button
                      className="btn bg-blue-500 text-white"
                      onClick={() => navigate(`/games/scout/${game._id}`)}
                    >
                      Ver Scout
                    </button>
                  </div>
                </div>
              </div>
            )
        )}
      </div>
    </div>
  );
};

export default Games;
